module.exports = __webpack_public_path__ + "img/16.588ffbec.png";